/* jshint esversion: 6 */
import store from '../store';
import router from '../router';

export function auth(to, from, next) {
    if (store.getters['auth/checkLogin']) {
        next();
    } else {
        next(false);
        router.rememberRoute = {
            name: to.name,
            params: to.params
        };
        router.replace({ name: 'login' });
    }
}
export function authAdmin(to, from, next) {
    if (
        store.getters['auth/checkLogin'] &&
        store.getters['auth/user'].is_admin
    ) {
        next();
    } else {
        next(false);
        router.rememberRoute = {
            name: to.name,
            params: to.params
        };
        router.replace({ name: 'login' });
    }
}

export function guest(to, from, next) {
    if (!store.getters['auth/checkLogin']) {
        next();
    } else {
        next(false);
        router.replace({ name: 'trips' });
    }
}

/**
 * When identity_validation_required_new_users is true and the user is a new user
 * who must validate and is not yet validated, redirect to identity validation page.
 * Call after auth (only runs when logged in).
 */
export function requireIdentityValidation(to, from, next) {
    const config = store.getters['auth/appConfig'];
    const user = store.getters['auth/user'];
    const smsValidated = !!(
        user &&
        (user.phone_verified === true || user.phone_verified_at)
    );
    const isIdentityValidated = !!(
        user &&
        (user.identity_validated === true ||
            (config && config.identity_validation_sms_enabled && smsValidated))
    );
    if (
        config &&
        user &&
        config.identity_validation_required_new_users &&
        user.identity_validation_required_for_user &&
        !isIdentityValidated
    ) {
        router.rememberRoute = {
            name: to.name,
            params: to.params,
            query: to.query
        };
        next(false);
        router.replace({ name: 'identity_validation' });
        return;
    }
    next();
}

export function profileComplete(to, from, next) {
    const user = store.getters['auth/user'];
    const config = store.getters['auth/appConfig'];
    
    // Check if user is loaded
    if (!user) {
        next(true);
        return;
    }
    
    // Use the backend-calculated profile_complete value
    // This respects the profile_validation_required flag in the database
    if (user.hasOwnProperty('profile_complete') && user.profile_complete === false) {
        router.rememberRoute = {
            name: to.name,
            params: to.params
        };
        console.log('🔴 [MIDDLEWARE] Profile incomplete: redirecting to profile_update');
        console.log('🔴 [MIDDLEWARE] User profile_complete:', user.profile_complete);
        next(false);
        router.replace({ name: 'profile_update' });
    } else {
        console.log('✅ [MIDDLEWARE] Profile complete - access granted');
        console.log('✅ [MIDDLEWARE] User profile_complete:', user.profile_complete);
        next();
    }
}
